'use strict';
const angular = require('angular');

/*@ngInject*/
export function WorkOrderCodesService($resource) {
  return $resource('/api/workorder-codes/:id', {
    name: '@_id'
  },{
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.WorkOrderCodesService', [])
  .factory('WorkOrderCodesService', WorkOrderCodesService)
  .name;



// WEBPACK FOOTER //
// ./client/components/workorder-codes/workorder-codes.service.js